import { vars } from '@etg/wings';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { Info } from '@phosphor-icons/react';
import type { Ticket, TicketPriceModalInfoProps } from '../../../model';
import { useToggle } from '../../../../../../../../common/custom-hooks/toggle';
import { getTripTotalPrice } from '../../../../../../utils/resultUtils';
import PriceBreakdownModal from '../../../../PriceBreakdownModal';
import type { TravelerPriceBreakdown } from '../../../../../../models';

const iconButtonStyles = css`
  margin-top: 3px;
`;

interface TicketPriceInfoWrapperProps {
  isRyanAirTicketingOrMarketingCarrierPresent: boolean;
  isVI: boolean;
  ticket: Ticket;
  ticketPriceModalInfo: TicketPriceModalInfoProps;
}

export const TicketPriceInfoWrapper = ({
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  ticket,
  ticketPriceModalInfo,
}: TicketPriceInfoWrapperProps) => {
  const { isOpen, handleOpen, handleClose } = useToggle();
  const {
    discountAmount,
    marketingCarrierNames,
    paymentMethodPrices,
    preSelectedExtraProducts,
    travelerPrices,
    travelerPriceBreakdown,
  } = ticketPriceModalInfo;
  const { cfarTicketPrices, flexibleTicketPrices } = ticket;
  return (
    <>
      <button className={cx(resetButtonStyle, iconButtonStyles)} onClick={handleOpen} type="button">
        <Info
          color={vars.colors.signal.information.light}
          data-testid="ticket-info-and-price-specification"
          size={24}
          weight="fill"
        />
      </button>
      {ticketPriceModalInfo && (
        <PriceBreakdownModal
          cfarTicketPrices={cfarTicketPrices}
          discountAmount={discountAmount}
          flexibleTicketPrices={flexibleTicketPrices}
          handleClose={handleClose}
          isOpen={isOpen}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          marketingCarrierNames={marketingCarrierNames}
          paymentMethodPrices={paymentMethodPrices}
          preSelectedExtraProducts={preSelectedExtraProducts}
          totalPrice={getTripTotalPrice(travelerPrices, flexibleTicketPrices, cfarTicketPrices)}
          travelerPriceBreakdown={travelerPriceBreakdown as TravelerPriceBreakdown[]}
        />
      )}
    </>
  );
};
